import React, { useContext, useState } from 'react';

import cx from 'classnames';
import FocusTrap from 'focus-trap-react';
import LocaleContext from 'lib/locale-context';

import A11yVisuallyHidden from 'components/a11y/a11y-visually-hidden';
import Link from 'components/link/link';

export type HeaderMenuProps = {
  items?: {
    isActive?: boolean;
    headerDropDownMenu?: {
      getUrl(lang: string): string;
      onClick?: () => void;
      title?: string | React.ReactNode;
      isActive?: boolean;
    }[];
    url?: string;
    onClick?: () => void;
    title?: string | React.ReactNode;
  }[];
};

function HeaderMenu({ items }: HeaderMenuProps) {
  const lang = useContext(LocaleContext);
  const [showMenu, setMenuVisible] = useState(false);
  return (
    <ul className="header-menu">
      {items &&
        items.map((item, index) => {
          const { isActive, headerDropDownMenu, url, title, onClick } = item;

          const classNameLink = cx({
            'header-menu__link': true,
            'is-active': isActive,
            'has-dropdown': headerDropDownMenu && !url,
          });

          return (
            <li className="header-menu__item" key={`header-menu-item-${index}`}>
              {url ? (
                <Link
                  className={classNameLink}
                  href={url}
                  onClick={onClick}
                  aria-current={isActive ? 'page' : undefined}
                >
                  {title}
                </Link>
              ) : null}

              {headerDropDownMenu ? (
                <FocusTrap
                  focusTrapOptions={{
                    escapeDeactivates: true,
                    onDeactivate: () => setMenuVisible(false),
                    initialFocus: false,
                    allowOutsideClick: true,
                  }}
                  active={showMenu}
                >
                  <div>
                    {/*
                                            if menu link is proper anchor, we show addiitonal button to expand dropdown
                                            however if menu link is just a dropdown opener, we don't need an additional button
                                        */}
                    <button
                      className={url ? 'header-menu__dropdown-toggle' : classNameLink}
                      aria-expanded={Boolean(showMenu)}
                      onClick={() => setMenuVisible(!showMenu)}
                      type="button"
                    >
                      {url ? (
                        <A11yVisuallyHidden>
                          {showMenu ? 'Hide submenu' : 'Show submenu'}
                        </A11yVisuallyHidden>
                      ) : (
                        title
                      )}
                    </button>

                    {showMenu ? (
                      <ul className="header-menu__dropdown" data-test-id="header-dropdown">
                        {headerDropDownMenu &&
                          headerDropDownMenu.map((menuItem, dropdownIndex) => {
                            const classNameSubLink = cx({
                              'header-menu__dropdown-link': true,
                              'is-active': menuItem.isActive,
                            });

                            return (
                              <li
                                className="header-menu__dropdown-item"
                                key={`header-menu--dropdown-item-${dropdownIndex}`}
                              >
                                <Link
                                  className={classNameSubLink}
                                  href={menuItem.getUrl(lang)}
                                  // eslint-disable-next-line react/jsx-handler-names
                                  onClick={menuItem.onClick}
                                >
                                  {menuItem.title}
                                </Link>
                              </li>
                            );
                          })}
                      </ul>
                    ) : null}
                  </div>
                </FocusTrap>
              ) : null}
            </li>
          );
        })}
    </ul>
  );
}

export default HeaderMenu;
